module.exports = "/_next/static/images/21c57851bfe429997a520af7321ea4f0-card-background-right-xs.jpg.webp";